import { render, staticRenderFns } from "./TaskWrapper.vue?vue&type=template&id=16804049&scoped=true&"
import script from "./TaskWrapper.vue?vue&type=script&lang=ts&"
export * from "./TaskWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./TaskWrapper.vue?vue&type=style&index=0&id=16804049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16804049",
  null
  
)

export default component.exports